import { AppRouterInstance } from 'next/dist/shared/lib/app-router-context.shared-runtime'

export const goToPhoneValidation = (router: AppRouterInstance) =>
  router.replace('/phoneValidationSSR', { scroll: false })
